import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatDatepickerInput } from '@angular/material/datepicker';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { Subscription, fromEvent } from 'rxjs';
import { FieldTypeConfig, FormlyTemplateOptions } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'formly-field-date',
  template: `
    <mat-form-field
      class="composed-date-input"
      (click)="picker.open()"
      (keydown.enter)="picker.open()"
      (keydown.space)="picker.open()">
      <input
        matInput
        [type]="to.type || 'text'"
        [formControl]="formControl"
        [matDatepicker]="picker"
        [matDatepickerFilter]="to.datepickerOptions.filter"
        [min]="to.minDate"
        [max]="to.maxDate"
        [formlyAttributes]="field"
        readonly
        #dateInput />
      <mat-datepicker-toggle matSuffix [for]="picker" disableRipple="true" tabIndex="-1"></mat-datepicker-toggle>
      <mat-datepicker touchUi="true" #picker [startAt]="startDate"></mat-datepicker>
    </mat-form-field>
  `,
})
export class FormlyFieldDatePickerComponent
  extends FieldType<FieldTypeConfig>
  implements AfterViewInit, AfterViewChecked, OnDestroy
{
  @ViewChild(MatInput, { static: false })
  formFieldControl: MatInput;

  @ViewChild(MatDatepickerInput, { static: false })
  datepickerInput: MatDatepickerInput<any>;

  @ViewChild('dateInput', { static: false })
  dateInput: ElementRef;

  startDate = new Date();
  eventSubscription: Subscription;

  ngAfterViewChecked() {
    this.formFieldControl.required = this.field.templateOptions.required;
  }

  ngAfterViewInit() {
    this.eventSubscription = fromEvent(this.dateInput.nativeElement, 'input').subscribe(() =>
      this.datepickerInput._onInput(this.dateInput.nativeElement.value)
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.eventSubscription?.unsubscribe();
  }
}
